import { appsyncQuery } from './appsync-client.js'

const SET_KEY = `
  mutation SetClaudeApiKey($apiKey: String!) {
    setClaudeApiKey(apiKey: $apiKey)
  }
`

const DELETE_KEY = `
  mutation DeleteClaudeApiKey {
    deleteClaudeApiKey
  }
`

const SUGGEST = `
  mutation SuggestManagerNote($input: SuggestManagerNoteInput!) {
    suggestManagerNote(input: $input) {
      sectionKey cardKey suggestion
    }
  }
`

export async function setClaudeApiKey(apiKey) {
  const data = await appsyncQuery(SET_KEY, { apiKey })
  return data?.setClaudeApiKey
}

export async function deleteClaudeApiKey() {
  const data = await appsyncQuery(DELETE_KEY)
  return data?.deleteClaudeApiKey
}

export async function suggestManagerNote(input) {
  const data = await appsyncQuery(SUGGEST, { input })
  return data?.suggestManagerNote
}
